import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Button, Table } from 'antd';
import { ApiOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { appConfig } from '../../../settings';
import { IRateImportItemRAW } from '../../../interfaces';
import { useRatesImportList } from '../../../hooks';
import { setRatesForcedImportUpdateTime, updateRateListItem } from '../../../middleware';
import { tF } from '../../../translate';
import { Catcher, LinkComponent, ReportStatusIcons, ShowRawDataInfo } from '../../../Components';
import '../../../customStyle/table.less';
import Styles from '../../styles/m_viewStyles.less';

export const DataImportTable: React.FC = observer(() => {
    const [isNeedUpdate, setNeedUpdate] = useState<boolean>(false);
    const list = useRatesImportList();

    useEffect(() => {
        const interval = setInterval(() => {
            if (isNeedUpdate) {
                setRatesForcedImportUpdateTime();
            }
        }, appConfig.updateViewInterval);
        return (): void => clearInterval(interval);
    }, [isNeedUpdate]);

    const tableColumns = [
        {
            title: tF('User'),
            dataIndex: 'user',
        },
        {
            title: tF('Type'),
            dataIndex: 'type',
        },
        {
            title: tF('Status'),
            dataIndex: 'statusIcon',
        },
        {
            title: tF('Error Message'),
            dataIndex: 'errorMessage',
        },
        {
            title: tF('Created at'),
            dataIndex: 'createdAt',
        },
    ];
    let isCalcNeedUpdate = false;
    const tableData = list.map((item: IRateImportItemRAW) => {
        const errorMessage = item.import_errors ? (
            <div className={Styles.dataContext}>
                <ShowRawDataInfo
                    transactionInfo={item.import_errors}
                    isError={item.status === 'failed'}
                    isLight={true}
                />
                <div className={Styles.shortErrorContext}>{JSON.stringify(item.import_errors)}</div>
            </div>
        ) : item.status && ['failed'].includes(item.status) ? (
            <Button onClick={(): void => updateRateListItem(item.id)} icon={<ApiOutlined />}>
                {tF('Error Message')}
            </Button>
        ) : null;

        if (!isCalcNeedUpdate && item.status && ['enqueued', 'in_progress'].includes(item.status)) {
            isCalcNeedUpdate = true;
        }

        return {
            key: item.id,
            statusIcon: <ReportStatusIcons status={item.status} />,
            user: item.user?.id ? (
                <LinkComponent
                    currentListComponent={'UsersList'}
                    id={item.user?.id}
                    name={item.user?.name || item.user?.email}
                />
            ) : (
                item.user?.name || item.user?.email || null
            ),
            type: item.type,
            errorMessage: errorMessage,
            createdAt: dayjs(item.createdAt).format(appConfig.formatDateTime),
        };
    });
    if (isNeedUpdate !== isCalcNeedUpdate) {
        setNeedUpdate(isCalcNeedUpdate);
    }

    return (
        <Catcher>
            <div className={Styles.tablePlace}>
                <Table
                    className={'table-theme'}
                    columns={tableColumns}
                    dataSource={tableData}
                    pagination={false}
                    size={'middle'}
                />
            </div>
        </Catcher>
    );
});
